const blogItems = [
    {
        id: "b-i-1",
        image: "images/blog-img-1.png",
        alt: "blog-img-1",
        day: 18,
        month: "oct",
        title: "STARTUP IDEAS NEEDS TO BE FUNDED",
        author: "Khalil Uddin",
        category: "development",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda fugit impedit consectetur nulla incidunt porro eligendi! Deleniti, optio maxime omnis placeat aut quisquam. Voluptatum vero eveniet nobis expedita similique quia!",
    },
    {
        id: "b-i-2",
        image: "images/blog-img-2.png",
        alt: "blog-img-2",
        day: 21,
        month: "oct",
        title: "USER INTERFACE DESIGNING ELEMENTS",
        author: "Shamim Mia",
        category: "development",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda fugit impedit consectetur nulla incidunt porro eligendi! Deleniti, optio maxime omnis placeat aut quisquam. Voluptatum vero eveniet nobis expedita similique quia!",
    }
]

export default blogItems;